module.exports = __webpack_public_path__ + "img/flower-type01-pc02.a1dd6d63.png";